import { createFileRoute } from '@tanstack/react-router'

import { isSuccess } from '@orus.eu/result'
import { anyOfPermissions } from '@orus.eu/right-access-management'

import { PlatformPendingRenewalPage } from '#/components/pages/backoffice/platform/platform-endorsement-page/platform-pending-renewal-page.tsx'
import { BackofficePartnerRenewalPageSkeleton } from '#/modules/renewal/back-office/partner-renewal-page/backoffice-partner-renewal-page-skeleton.tsx'
import { BackofficePartnerRenewalPage } from '#/modules/renewal/back-office/partner-renewal-page/backoffice-partner-renewal-page.tsx'
import { PARTNER_RENEWAL_DETAILS_QUERY_OPTIONS } from '#/modules/renewal/back-office/partner-renewal-page/partner-renewal-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/contracts/$subscriptionId/renewals/$endorsementId/')({
  beforeLoad: async (options) => {
    await requirePermissions(options, [
      anyOfPermissions(
        'contract.sign',
        'contract.sign.relatedOnly',
        'renewal.manageForClient',
        'renewal.manageForClient.relatedOnly',
      ),
    ])
    const sessionResult = await options.context.session.getSessionResult()
    return { userType: isSuccess(sessionResult) ? sessionResult.output.permissions.type : undefined }
  },
  loader: async ({ context, params }) => {
    switch (context.userType) {
      case 'partner':
        await context.queryClient.ensureQueryData(
          context.trpc.renewal.getPartnerRenewalDetails.queryOptions(
            { renewalId: params.endorsementId },
            PARTNER_RENEWAL_DETAILS_QUERY_OPTIONS,
          ),
        )
        return
      case 'platform':
      case 'client':
      case undefined:
        return
    }
  },
  pendingComponent: BackofficePartnerRenewalPageSkeleton,
  component: function Component() {
    const { subscriptionId } = Route.useParams()
    const { userType } = Route.useRouteContext()
    switch (userType) {
      case 'partner':
        return <BackofficePartnerRenewalPage key={subscriptionId} />
      case 'platform':
      case 'client':
      case undefined:
        return <PlatformPendingRenewalPage key={subscriptionId} />
    }
  },
})
